import React, { useContext, useState, useCallback, useRef, useEffect } from "react";
import studylistContext from "../../../../../context/studylist/StudylistContext";
import DropdownMoreIcon from "../../../../../components/SVGComponents/DropdownMoreIcon";
import {
  Checkbox,
  Dropdown,
  Icon,
  PrimaryButton,
  Stack,
  TextField,
  Calendar,
  TooltipHost,
} from "@fluentui/react";
import FilterPopUp from "../FilterPopUp";
import { t } from "i18next";
import loaderContext from "../../../../../context/loader/LoaderContext";
import themeContext from "../../../../../context/theme/ThemeContext";
import {MAX_FILTER_BADGES_LENGTH} from '../../../../../constants/Constants';

const ContentFilter = (props) => {
  const {
    setAllStudies,
    studyData,
    columns,
    allStudies,
    searchDto,
    setSearchDto,
    sortGlobal,
    setSortGlobal,
    filterInputValues,
    showFilters,
    setShowFilters,
    setApplyClick,
    filterBadges,
    setFilterBadges,
    removeBadgeFromFilter,
    storefilterBadges,
    setPatientDetail,
    trackApplyButton,
    setTrackApplyButton,
    patientNameBadgeShow,
    setPatientNameBadgeShow,
    handleEnterKeyPress,
    setFilterInputValues,
    storefilterInputValues,
    handleRefresh,
    selectedValue,
  } = useContext(studylistContext);

  const { getThemeColor } = useContext(themeContext);

  const { enableButtonTourPurpose,setEnableButtonTourPurpose } = useContext(loaderContext); 

  const [showFilterOptions, setShowFilterOptions] = useState(false);
  const [showMoreFilter, setShowMoreFilter] = useState(false);

  const onHoverIn = () => {
    setShowMoreFilter(true);
  };
  const onHoverOut = () => {
    setShowMoreFilter(false);
  };
  
  useEffect(()=>{
    if(enableButtonTourPurpose.showFilterPopup){
      setShowFilterOptions(true);
    }else{
      setShowFilterOptions(false);
    }
  },[enableButtonTourPurpose])

  const [maxFilterBadgesLength, setMaxFilterBadgesLength] = useState(MAX_FILTER_BADGES_LENGTH);
    
  useEffect(() => {
    if (selectedValue === "study_3" && MAX_FILTER_BADGES_LENGTH>1) {
      setMaxFilterBadgesLength(3);
    } else {
      setMaxFilterBadgesLength(MAX_FILTER_BADGES_LENGTH);
    }
  }, [selectedValue]);

  const addIcon = {
    iconName: "AddTo",
    cursor: "pointer",
  };

  const addFilterActive = {
    rootHovered:{
      background:"red"
    },
    root:{
      fontSize: "12px",
      fontWeight: "400",
      padding: "0px 3px",
      whiteSpace: "nowrap",
      background: "#404040",
      borderColor: "#404040",
      borderRadius: "7px !important",
      minWidth: "71px"
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          // marginLeft: "10px",
          alignItems: "center",
          width: storefilterBadges?.length > 0 ? "50%" : "fit-content",
        }}
      >
        {/* <p className="sort-search-text">Filter By</p> */}
        {/* {storefilterBadges.length == 0 && ( */}
        <div style={{ display: "flex",marginLeft:'10px' }}>
          <PrimaryButton
            iconProps={addIcon}
            onClick={() => {
              setShowFilters((prev) => !prev);
              setShowFilterOptions((prev) => !prev);
            }}
            text={t("button.filter")}
            //className={showFilterOptions?"common-default-inactive-button study-list-filter-button":"common-default-active-button study-list-filter-button"}
          />
        </div>
      {/* )} */}
        {storefilterBadges?.length > 0 &&
          storefilterBadges.map(
            (item, ind) => {
              return (
                ind <= maxFilterBadgesLength-1 && (
                  <div
                    key={ind}
                    className="study-list-badge-list-view"
                    style={{ marginLeft: "10px", cursor: "auto" }}
                    //onClick={() => setShowFilterOptions(true)}
                  >
                    <span className="study-list-badge-text-list-view">
                      {item.label}
                    </span>

                    <Icon
                      onClick={(event) => {
                        event.stopPropagation();
                        removeBadgeFromFilter(item);
                      }}
                      style={{
                        cursor: "pointer",
                        lineHeight: "2",
                        marginLeft: "5px",
                      }}
                      iconName="Cancel"
                      className="ms-fontSize-10"
                    ></Icon>
                  </div>
                )
              );
            }

            // </ScrollMenu>
          )}

        {storefilterBadges?.length > maxFilterBadgesLength &&
          // <ScrollMenu
          //   LeftArrow={LeftArrowFunction}
          //   RightArrow={RightArrowFunction}
          //   onInit={restorePosition}
          //   onScroll={savePosition}
          //   onWheel={onWheel}
          //   apiRef={apiRef}
          // >
          storefilterBadges.map(
            (item, ind) => {
              return (
                ind == maxFilterBadgesLength && (
                  <div
                    key={ind}
                    className="study-list-badge-list-view more-filter-hover"
                    style={{ marginLeft: "10px", cursor: "pointer" }}
                    onMouseEnter={onHoverIn}
                    onMouseLeave={onHoverOut}
                    //onClick={() => setShowFilterOptions(true)}
                  >
                    <span className="study-list-badge-text-list-view">
                      {/* +{storefilterBadges.length - (maxFilterBadgesLength > 1 ? maxFilterBadgesLength - 1: maxFilterBadgesLength) - 1}&nbsp; */}
                      +{storefilterBadges.slice(maxFilterBadgesLength, storefilterBadges.length).length}&nbsp;
                      <DropdownMoreIcon />
                    </span>
                    {showMoreFilter && (
                      <div
                        className="more-popup-hover"
                        style={{border: getThemeColor("border")}}
                        onMouseEnter={onHoverIn}
                        onMouseLeave={onHoverOut}
                      >
                        {storefilterBadges.map((item, ind) => {
                          return (
                            ind > (maxFilterBadgesLength - 1) && (
                              <div
                                key={ind}
                                className="study-list-badge-list-view"
                                style={{
                                  marginLeft: "10px",
                                  cursor: "auto",
                                  marginBottom: "10px",
                                }}
                                //onClick={() => setShowFilterOptions(true)}
                              >
                                <span className="study-list-badge-text-list-view">
                                  {item.label}
                                </span>

                                <Icon
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    removeBadgeFromFilter(item);
                                  }}
                                  style={{
                                    cursor: "pointer",
                                    // color: "white",
                                    lineHeight: "2",
                                    marginLeft: "5px",
                                  }}
                                  iconName="Cancel"
                                  className="ms-fontSize-10"
                                ></Icon>
                              </div>
                            )
                          );
                        })}
                      </div>
                    )}
                  </div>
                )
              );
            }

            // </ScrollMenu>
          )}
          {storefilterBadges.length > 0 &&<div style={{marginLeft:'10px'}}>
          <PrimaryButton
            text="Clear All"
            onClick={() =>
              setTimeout(() => {
                props.handleClearFilter();
              }, 500)
            }
          />
        </div>}
      </div>
      
      <FilterPopUp
        show={showFilterOptions}
        onClickOutside={() => {
          setFilterInputValues(storefilterInputValues);
          setShowFilterOptions(false);
        }}
        setShowFilterOptions={setShowFilterOptions}
      />
    </>
  );
};

export default ContentFilter;
